import instantsearch from 'instantsearch.js';
import {searchBox, configure, hits, sortBy, hitsPerPage} from 'instantsearch.js/es/widgets';
import {connectHitsPerPage, connectSortBy} from 'instantsearch.js/es/connectors';
import TypesenseInstantsearchAdapter from 'typesense-instantsearch-adapter';

( function( app ) {
  const COMPONENT = {
    typesenseAdapter: null,
    searchInitialized: false,
    metaContainer: null,
    facets: {},
    init: function() {
      this.setFacets();
      this.metaContainer = document.querySelector( '#shop-category-meta' );
      const adapterConfig = {
        server: {
          apiKey: siteInfo?.searchApi?.key,
          nodes: [
            {
              host: siteInfo?.searchApi?.host,
              port: siteInfo?.searchApi?.port,
              protocol: siteInfo?.searchApi?.protocol,
              path: siteInfo?.searchApi?.path,
            },
          ],
        },
        collectionSpecificSearchParameters: {
          products: {
            query_by: siteInfo?.search?.searchFields,
          },
          category_seo: {
            query_by: 'title',
          },
        },
      };

      this.typesenseAdapter = new TypesenseInstantsearchAdapter( adapterConfig );
      const searchClient = this.typesenseAdapter.searchClient;
      const instanceArgs = {
        searchClient,
        indexName: 'products',
        future: {
          preserveSearchParameters: true,
        },
      };
      const categoryDescriptionClientArgs = {
        searchClient,
        indexName: 'category_seo',
        routing: false,
        future: {
          preserveSearchParameters: true,
        },
      };

      const initialUiState = {
        products: {
          sortBy: 'products/sort/rank:asc,brand_ranking:asc',
          refinementList: {
            status: ['In Stock'],
          },
        },
      };

      if ( siteInfo?.search?.query?.length > 0 ) {
        initialUiState.products.query = siteInfo?.search?.query;
      }

      if ( siteInfo?.search?.queriedCategory ) {
        switch ( siteInfo?.search?.queriedCategory ) {
          case 'new-products':
            initialUiState.products.sortBy = 'products/sort/created_at:desc,rank:asc,brand_ranking:asc';
            initialUiState.products.refinementList = initialUiState.products.refinementList || {};
            initialUiState.products.refinementList.status = ['New'];
            break;
          case 'bargain-basement':
            initialUiState.products.refinementList = initialUiState.products.refinementList || {};
            initialUiState.products.refinementList.status = siteInfo.search.isWholesale ? ['Wholesale On Sale'] : ['On Sale'];
            break;
          case 'rebate':
            initialUiState.products.refinementList = initialUiState.products.refinementList || {};
            initialUiState.products.refinementList.status = ['Rebate'];
            break;
          default:
            initialUiState.products.breadcrumb = {};
            initialUiState.products.hierarchicalMenu = {};
            initialUiState.products.breadcrumb['categories.lvl0'] = [siteInfo?.search?.queriedCategory];
            initialUiState.products.hierarchicalMenu['categories.lvl0'] = [siteInfo?.search?.queriedCategory];
        }
      }

      const urlParams = new URLSearchParams( window.location.search );
      if ( window.location.search.includes( 'brand=' ) ) {
        const brands = urlParams.getAll( 'brand' ).map( decodeURIComponent );

        if ( brands.length > 0 ) {
          initialUiState.products.refinementList = initialUiState.products.refinementList || {};
          initialUiState.products.refinementList.brand = brands;
        }
      }

      if ( urlParams.has( 'status' ) ) {
        const status = urlParams.getAll( 'status' ).map( decodeURIComponent );
        if ( status.length > 0 ) {
          initialUiState.products.refinementList = initialUiState.products.refinementList || {};
          initialUiState.products.refinementList.status = status;
        }
      }

      if ( siteInfo?.search?.isShop ) {
        instanceArgs.routing = true;
      }

      if ( Object.keys( initialUiState.products ).length > 0 ) {
        instanceArgs.initialUiState = initialUiState;
      }

      this.searchInstance = instantsearch( instanceArgs );
      if ( siteInfo?.search?.isShop ) {
        this.categoryInstance = instantsearch( categoryDescriptionClientArgs );
        this.searchInstance.on( 'render', () => {
          this.handleCategorySearch();
        } );
      }
    },
    searchInstance: null,
    categoryInstance: null,
    categorySeoData: null,
    categorySeoRequestId: 0,
    setFacets: function() {
      this.facets = {
        availability: siteInfo?.search?.isWholesale ? 'wholesale_is_available' : 'is_available',
        price: siteInfo?.search?.isWholesale ? 'wholesale_price' : 'price',
      };
    },
    getWidgets: async function() {
      const configuration = {
        hitsPerPage: window?.siteInfo?.search.perPage,
        maxValuesPerFacet: 300,
        filters: `${this.facets.availability}:true`,
      };

      let widgets = [
        searchBox( {
          container: '#searchbox',
          placeholder: 'Search...',
          showSubmit: true,
          showReset: true,
          showLoadingIndicator: false,
          cssClasses: {
            input: 'peer w-full font-bold border-0 rounded bg-brand-off-white focus:ring-0 col-[1_/_span_2] row-start-1 pl-[38px] transition-all duration-150 ease-in-out text-brand-charcoal',
            root: '[&:not(:focus-within)_ol]:hidden [&:not(:focus-within)_.ais-SearchBox-reset]:hidden [&:not(:focus-within)_.ais-SearchBox-input]:pl-3.5',
            form: 'grid grid-cols-[1fr_52px]',
            submit: 'grid place-content-center col-start-2 row-start-1',
            submitIcon: 'size-3.5',
            reset: 'grid col-start-1 row-start-1 w-[38px] place-content-center',
          },
        } ),
        configure( configuration ),
      ];

      if ( window?.siteInfo?.search?.isShop ) {
        const shopWidgets = await app.components?.shop?.getWidgets( this.typesenseAdapter );
        widgets.push( hitsPerPage( {
          container: '#per-page',
          items: [
            {label: '12', value: 12},
            {label: '24', value: 24, default: true},
            {label: '48', value: 48},
          ],
        } ) );

        let defaultSort = 'products/sort/rank:asc,brand_ranking:asc';
        if ( siteInfo?.search?.queriedCategory && siteInfo?.search?.queriedCategory === 'new-products' ) {
          defaultSort = 'products/sort/created_at:desc,rank:asc,brand_ranking:asc';
        }

        widgets.push( sortBy( {
          container: '#sort-by',
          items: [
            {label: 'Default', value: defaultSort},
            {label: 'Price: Low to High', value: `products/sort/${this.facets.price}:asc,rank:asc,brand_ranking:asc`},
            {label: 'Price: High to Low', value: `products/sort/${this.facets.price}:desc,rank:asc,brand_ranking:asc`},
            {label: 'Brand: A to Z', value: 'products/sort/brand:asc,rank:asc,brand_ranking:asc'},
            {label: 'Brand: Z to A', value: 'products/sort/brand:desc,rank:asc,brand_ranking:asc'},
            {label: 'Part Number: A to Z', value: 'products/sort/sku:asc,rank:asc,brand_ranking:asc'},
            {label: 'Part Number: Z to A', value: 'products/sort/sku:desc,rank:asc,brand_ranking:asc'},
          ],
        } ) );
        widgets = widgets.concat( shopWidgets );
      } else {
        const virtualHitsPerPage = connectHitsPerPage( () => null );
        widgets.push( virtualHitsPerPage( {
          items: [
            {label: '8', value: 8, default: true},
            {label: '0', value: 0},
          ],
        } ) );

        const sortByWidget = connectSortBy( () => null );
        widgets.push( sortByWidget( {
          items: [
            {label: 'Rank', value: 'products/sort/rank:asc,brand_ranking:asc'},
          ],
        } ) );

        widgets.push( hits( {
          container: '#hits',
          cssClasses: {
            list: 'empty:hidden bg-white m-0 p-0 max-h-[75dvh] overflow-y-auto shadow rounded-[3px]',
            item: 'first-of-type:rounded-t-[3px] last-of-type:rounded-b-[3px] items-center bg-white shadow-[0_0_0_1px_rgba(35,38,59,.05),0_1px_3px_0_rgba(35,38,59,.15)] flex hover:bg-brand-primary hover:text-white transition-colors duration-150',
          },
          transformItems( items, {results} ) {
            if ( results.query.length === 0 || results.query === '*' ) return [];
            if ( items.length > 1 ) {
              items.push( {
                title: 'View All',
                llViewAll: true,
                url: `/shop/?query=${results.query}`,
              } );
            }
            return items;
          },
          templates: {
            empty( results, response ) {
              if ( results.query.length === 0 || results.query === '*' ) return null;
              return `<div class="bg-white shadow-[0_0_0_1px_rgba(35,38,59,.05),0_1px_3px_0_rgba(35,38,59,.15)] rounded-b-[3px] py-8 px-5">No results found for <q>${results.query}</q></div>`;
            },
            item( item ) {
              if ( item.llViewAll ) {
                return `
                  <a href="${item.url}" class="hit-link w-full px-5 py-3 text-sm line-clamp-2 duration-0">
                    ${item.title}
                    <svg class="icon icon-Right-Arrow">
                       <use xlink:href="#icon-Right-Arrow"></use>
                    </svg>
                  </a>
                `;
              } else {
                let images = '';
                for ( let i = 0; i < 1; i++ ) {
                  if ( typeof item.images[i] === 'undefined' ) break;
                  images += `
                    <img src="${item.images[i]}" alt="Photo of ${item.title}" class="aspect-square border border-gray-200 rounded object-contain h-full size-10" loading="lazy" />
                  `;
                }

                return `
                  <a href="/product/${item.slug}" class="hit-link flex gap-4 items-center w-full px-5 py-3 text-sm duration-0">
                    ${images}
                    <span class="line-clamp-2">${item.title}</span>
                  </a>
                `;
              }
            },
          },
        } ) );
      }

      return widgets;
    },
    handleCategorySearch: async function() {
      const currentState = this.searchInstance.helper.state;
      const categoryLevels = ['categories.lvl0', 'categories.lvl1', 'categories.lvl2'];
      const categoryPath = [];

      // Keep every ancestor, not just the leaf, so a category without its own
      // category_seo entry falls back up the tree the way the PHP archive does.
      categoryLevels.forEach( ( level ) => {
        const refinements = currentState.hierarchicalFacetsRefinements?.[level];
        if ( refinements && refinements.length > 0 ) {
          refinements[0].split( '>>' ).forEach( ( segment ) => {
            const categoryName = segment.trim();
            if ( categoryName && !categoryPath.includes( categoryName ) ) {
              categoryPath.push( categoryName );
            }
          } );
        }
      } );

      // Render fires often; only the newest lookup may touch the DOM.
      const requestId = ++this.categorySeoRequestId;

      if ( categoryPath.length > 0 ) {
        categoryPath.reverse();
        let resultsFound = false;
        for ( const path of categoryPath ) {
          const response = await this.queryCategorySeo( path, requestId );
          if ( requestId !== this.categorySeoRequestId ) {
            return;
          }

          if ( response ) {
            resultsFound = true;
            break;
          }
        }

        if ( !resultsFound ) {
          this.metaContainer.innerHTML = '';
          this.metaContainer?.classList.add( 'hidden' );
        }
      } else {
        this.metaContainer.innerHTML = '';
        this.metaContainer?.classList.add( 'hidden' );
      }
    },
    queryCategorySeo: async function( categoryName, requestId = null ) {
      try {
        const response = await this.typesenseAdapter.searchClient.search( [
          {
            indexName: 'category_seo',
            params: {
              query: `"${categoryName}"`,
              query_by: 'title',
              hitsPerPage: 50,
            },
          },
        ] );

        if ( requestId !== null && requestId !== this.categorySeoRequestId ) {
          return false;
        }

        const seoData = this.findBestCategorySeoHit( response.results[0]?.hits, categoryName );
        if ( seoData ) {
          this.categorySeoData = seoData;
          this.updateCategorySeoContent( seoData );
          return true;
        }
        return false;
      } catch ( error ) {
        return false;
      }
    },
    /*
     * Typesense scores every category_seo entry that contains the searched
     * phrase identically, so "Exhaust" ties across "Exhaust", "Exhaust Valve"
     * and "Exhaust Valves" and the winner comes down to index order. Break
     * those ties by how close the title is to the category name: exact match
     * first, then Typesense's own relevance, then the shortest (least padded)
     * title.
     */
    normalizeCategorySeoTitle: function( title ) {
      return `${title ?? ''}`.toLowerCase().replace( /[^a-z0-9]+/g, ' ' ).trim();
    },
    findBestCategorySeoHit: function( hits, categoryName ) {
      if ( !hits?.length ) return null;

      const needle = this.normalizeCategorySeoTitle( categoryName );
      let best = null;
      let bestScore = null;

      hits.forEach( ( hit, index ) => {
        const title = this.normalizeCategorySeoTitle( hit.title );
        const score = [
          title === needle ? 0 : 1,
          -( hit.text_match || 0 ),
          title.length,
          index,
        ];

        if ( bestScore === null || this.compareCategorySeoScores( score, bestScore ) < 0 ) {
          bestScore = score;
          best = hit;
        }
      } );

      return best;
    },
    compareCategorySeoScores: function( a, b ) {
      for ( let i = 0; i < a.length; i++ ) {
        if ( a[i] !== b[i] ) return a[i] < b[i] ? -1 : 1;
      }

      return 0;
    },
    updateCategorySeoContent: function( seoData ) {
      let categoryTitleHtml = '';
      if ( seoData.title ) {
        let titleText = `${seoData.title}`;
        if ( seoData.keywords ) {
          titleText += ` - ${seoData.keywords}`;
        }

        categoryTitleHtml = `<h1 id="shop-category-title" class="hdg-3">${seoData.title}</h1>`;
        document.title = `${titleText} - ${window.siteInfo.name}`;
      }

      let categoryDescriptionHtml = '';
      if ( seoData.description ) {
        const metaDescription = document.querySelector( 'meta[name="description"]' );
        let descriptionText = seoData.description;
        if ( seoData.keywords ) {
          descriptionText += ` - ${seoData.keywords}`;
        }

        if ( metaDescription ) {
          metaDescription.setAttribute( 'content', descriptionText );
        }
        categoryDescriptionHtml = `<p id="shop-category-description" class="paragraph-small">${seoData.description}</p>`;
      }

      this.metaContainer.innerHTML = categoryTitleHtml + categoryDescriptionHtml;
      this.metaContainer?.classList.remove( 'hidden' );

      window.dispatchEvent( new CustomEvent( 'categorySeoLoaded', {
        detail: {seoData: seoData},
      } ) );
    },
    finalize: async function() {
      const widgets = await this.getWidgets();
      this.searchInstance.addWidgets( widgets );

      if ( !window.siteInfo?.search?.isShop ) {
        document.querySelector( '#temp-search-input' ).addEventListener( 'focus', ( event ) => {
          document.querySelector( '#temp-search-input' )?.remove();
          this.searchInstance.start();
          this.searchInitialized = true;

          document.querySelector( '.ais-SearchBox-form' )?.addEventListener( 'submit', function( event ) {
            event.preventDefault();
            app.components?.common?.updateSearchLink();
            window.location.href = document.querySelector( '#shop-search-link' ).getAttribute( 'href' );
          } );

          document.querySelector( '.ais-SearchBox-form .ais-SearchBox-input' )?.focus();

          document.querySelector( '#searchbox form' )?.addEventListener( 'submit', function( event ) {
            const searchInputValue = document.querySelector( '#searchbox input' ).value;
            const url = new URL( siteInfo?.shopUrl, window.location.origin );
            url.searchParams.set( 'query', searchInputValue );
            window.location.href = url.href;
          } );
        } );
      } else {
        document.querySelector( '#temp-search-input' )?.remove();
        this.searchInstance.start();
        this.searchInitialized = true;

        document.querySelector( '#searchbox form' ).addEventListener( 'submit', function( event ) {
          const searchInputValue = document.querySelector( '#searchbox input' ).value;
          const url = new URL( siteInfo?.shopUrl, window.location.origin );
          url.searchParams.set( 'query', searchInputValue );
          window.location.href = url.href;
        } );
      }
    },
  };

  app.registerComponent( 'search', COMPONENT );
} )( app );
